<template>
    <div class="alert-error">
        <div class="itens-alert">
            <img src="../../assets/error.png" class="img-error" alt="">
            <span class="text-error">{{ textError }}</span>
            <button-game :name="nameButton" typeLogin="default" :action="action" v-show="showButton"></button-game>
        </div>
    </div>
</template>
<script>
import ButtonGame from '../Buttons/ButtonGame'
export default {
    components : {
        ButtonGame
    },
    props : {
        textError : {
            type : String,
            required : true
        },
        nameButton : {
            type : String,
            required : true
        },
        action : {
            type : String,
            required : false
        },
        showButton : {
            type : Boolean,
            required : false,
            default: true
        }
    }
    
}
</script>
<style lang="scss" scoped>
    .alert-error{
        background-color: #404040f3;
        width: 100%;
        height: calc(100vh + 60px);
        position: fixed;
        top: -60px;
        z-index: 1000;

        .itens-alert{

            width: 85%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 auto;

            .img-error{

                width: 170px;
            }

            .text-error{
                letter-spacing: 1px;
                line-height: 29px;
                text-transform: uppercase;
                font-weight: 700;
                font-size: 17px;
                color: white;
                text-align: center;
                padding: 10% 0;
            }
        }
    }
</style>
